import { inject } from '@angular/core'

import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'

import { lastValueFrom } from 'rxjs'

import { ApplicationApi } from '@flowx/designer/shared/api/application.api'
import { RuntimeApiService } from '@flowx/designer/shared/api/runtime.api'
import { ToastMessageService } from '@flowx/designer/shared/services/toast-message.service'

type ImportProjectStore = {
  importInProgress: boolean
}

const initialState: ImportProjectStore = {
  importInProgress: null,
}

export const ImportProjectStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (
      store,
      runtimeApiService = inject(RuntimeApiService),
      applicationApi = inject(ApplicationApi),
      toastMsgService = inject(ToastMessageService)
    ) => ({
      // Only uploads the archive: the import runs server-side and reports through its notifications,
      // so `importInProgress` covers the upload alone.
      importApplication: async (casUserId: string, file: File, workspaceId?: string) => {
        if (!store.importInProgress()) {
          patchState(store, { importInProgress: true })
          try {
            await lastValueFrom(applicationApi.importApplication(casUserId, file, workspaceId))
          } catch (err) {
            toastMsgService.showErrorMessage(err.error.title ?? 'Error importing application')
          } finally {
            patchState(store, { importInProgress: false })
          }
        }
      },
      importBuild: async (casUserId: string, file: File, workspaceId?: string) => {
        if (!store.importInProgress()) {
          patchState(store, { importInProgress: true })
          try {
            await lastValueFrom(runtimeApiService.importBuild(casUserId, file, workspaceId))
          } catch (err) {
            toastMsgService.showErrorMessage(err.error.title ?? 'Error importing application')
          } finally {
            patchState(store, { importInProgress: false })
          }
        }
      },
    })
  )
)
